import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import Authentication from '../../../libs/api/services/Authentication'
import Share from '../../../libs/api/services/Share'

export default function SharedAccessScreen() {
    const { ShareID } = useParams()
    const [request, setRequest] = useState()
    const [pending, setPending] = useState()
    const [error, setError] = useState()

    const KeyRef = useRef()

    const login = (shareWithId) => {
        Authentication.loginByUserId({
            userId: shareWithId,
            accessKey: KeyRef.current.value.trim()
        }, ShareID, `/Dashboard/Patient/${request.patient.id}/Dashboard`
        ).catch(e => setError(e.message))
    }

    useEffect(() => {
        const load = async () => {
            const validate = await Share.ValidateRequest(ShareID).catch(e => setError("Please use a valid share access key"))
            setRequest(validate)
            var consents = []
            if (!validate) return setError("Invalid Access Link")
            if (validate && validate.consents) {
                consents =
                    validate.consents.filter(a => a.consents && a.consents.consentType === "REQUIRED"
                        && a.consents.status === "Pending"
                    )

                // console.log(validate.consents)
            }
            if (!validate.request.shareWith || !validate.request.shareWith.id) return setError("Invalid Access Link")
            if (!consents || consents.length === 0) {
                // Cannot do auto login because access Key is now required
                // return login(validate.shareWith.id)
            }
            else setPending(consents)
        }
        load()
    }, [])
    return (
        <div className='d-flex align-items-center justify-content-center' style={{ height: '100vh', width: '100vw' }}>
            <div className={` p-3 text-dark shadow rounded `}>
                {error && !request && <h3 className='text-center text-danger'>{error}</h3>}
                {!error && !pending && !request && <div className='text-center'>
                    <FontAwesomeIcon icon={faSpinner} spin size={'6x'} />
                    <div className='p-3'><b>Validating your request</b></div>
                </div>}
                {request && <div className='text-center'>
                    {error && error === "Invalid Access Link"
                        ?
                        <h3 className='text-center text-danger'>{error}</h3>
                        :
                        <>
                            <h1>Access Key</h1>
                            <p>Please confirm your access key or DrData password</p>
                            {error && <h3 className='text-center text-danger'>{error}</h3>}
                            <input className='form-control p ' ref={KeyRef} placeholder='Access Key' />
                            {pending && <div className='text-center m-3'><p>Please note that some information may not be available to you at this time as there are items still pending consent approval</p>
                            </div>}
                            <button onClick={() => login(request.request.shareWith.id)} className='btn'>Continue</button>
                        </>
                    }
                </div>}
            </div>


        </div>
    )
}//share/5b66b4fc-7aaa-40d0-2df7-08dd024a455d 
// TO DO : CHECK WHY CONSENT FAILING
// REset key auth
//f8a69ac1-6dfa-4faf-869b-faae655727e0
//9a87f90a-fec8-47db-e50d-08dd023ed117
// Approve is approving all requests
// C3C339C2-4B3D-486F-F56A-08DD0260501D -  c4e605cc-635d-4600-aa8c-641b057283dd
//https://localhost:44458/facilities?goto=/Dashboard/Patient/f8bf4c09-494a-432e-5f7a-08dd02578cac/Dashboard